import { useState, useEffect } from "react";
import {
  Users,
  Search,
  Plus,
  Edit,
  Ban,
  Power,
  X,
  Save,
  Loader2,
  RefreshCw,
  Mail,
  Building2,
  Shield,
  UserPlus,
  AlertCircle,
  Phone,
  Send,
  Clock,
  CheckCircle,
  XCircle,
  CreditCard,
  Eye,
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Checkbox } from "./ui/checkbox";
import Swal from "sweetalert2";

const GestionUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [invitaciones, setInvitaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [editingUsuario, setEditingUsuario] = useState(null);
  const [showConductorModal, setShowConductorModal] = useState(false);
  const [conductoresDisponibles, setConductoresDisponibles] = useState([]);
  const [conductorSeleccionado, setConductorSeleccionado] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    tipo: "cliente",
    empresa_id: "",
    active: true,
    roles: [],
  });
  const [formInvite, setFormInvite] = useState({
    name: "",
    email: "",
    roles: [],
  });
  const [formConfig, setFormConfig] = useState({
    tipos: {},
    empresas: [],
    roles: [],
    all_roles: {},
    can_create_direct: false,
    can_invite: false,
    admin_empresa: null,
  });
  const [filters, setFilters] = useState({
    buscar: "",
    active: "",
    tipo: "",
    empresa_id: "",
  });
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
  });

  useEffect(() => {
    loadFormConfig();
  }, []);

  useEffect(() => {
    loadUsuarios();
  }, [filters, pagination.current_page]);

  const getApiUrl = () => {
    return process.env.REACT_APP_API_URL || "http://localhost:8000/api";
  };

  const getHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  };
  // Función para verificar si "conductor" está seleccionado
  const tieneRolConductor = () => {
    return formInvite.roles.some((roleId) => {
      const role = formConfig.roles?.find((r) => r.id === roleId);
      return role?.name?.toLowerCase().includes("conductor");
    });
  };

  // Cargar conductores disponibles
  const loadConductoresDisponibles = async () => {
    try {
      const response = await fetch(`${getApiUrl()}/flota/conductores`, {
        headers: getHeaders(),
      });
      if (response.ok) {
        const data = await response.json();
        setConductoresDisponibles(data);
      }
    } catch (error) {
      console.error("Error cargando conductores:", error);
    }
  };
  const loadFormConfig = async () => {
    try {
      const response = await fetch(`${getApiUrl()}/users/form/data`, {
        headers: getHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        setFormConfig(data.data);
      }
    } catch (error) {
      console.error("Error cargando configuración:", error);
    }
  };

  const loadUsuarios = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: pagination.current_page,
        perPage: 15,
      });

      if (filters.buscar) params.append("buscar", filters.buscar);
      if (filters.active) params.append("active", filters.active);
      if (filters.tipo) params.append("tipo", filters.tipo);
      if (filters.empresa_id) params.append("empresa_id", filters.empresa_id);

      const response = await fetch(`${getApiUrl()}/users?${params}`, {
        headers: getHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        setUsuarios(data.data);
        setPagination(data.pagination);
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "No se pudieron cargar los usuarios", "error");
    } finally {
      setLoading(false);
    }
  };

  const loadInvitaciones = async () => {
    try {
      const response = await fetch(`${getApiUrl()}/users/invitations/list`, {
        headers: getHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        setInvitaciones(data.data);
      }
    } catch (error) {
      console.error("Error cargando invitaciones:", error);
    }
  };

  const handleOpenCreateModal = () => {
    setEditingUsuario(null);
    setFormData({
      name: "",
      email: "",
      password: "",
      tipo: formConfig.admin_empresa?.tipo_usuario_auto || "cliente",
      empresa_id: formConfig.admin_empresa?.id || "",
      active: true,
      roles: [],
    });
    setShowModal(true);
  };

  const handleOpenInviteModal = () => {
    setFormInvite({
      name: "",
      email: "",
      roles: [],
    });
    loadInvitaciones();
    setShowInviteModal(true);
  };

  const handleEdit = (usuario) => {
    setEditingUsuario(usuario);
    setFormData({
      name: usuario.name,
      email: usuario.email,
      password: "",
      tipo: usuario.tipo,
      empresa_id: usuario.empresa_id || "",
      active: usuario.active,
      roles: usuario.roles?.map((r) => r.id) || [],
    });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const url = editingUsuario
        ? `${getApiUrl()}/users/${editingUsuario.id}`
        : `${getApiUrl()}/users`;

      const method = editingUsuario ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: editingUsuario ? "Usuario actualizado" : "Usuario creado",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
        });

        setShowModal(false);
        loadUsuarios();
      } else {
        if (result.errors) {
          const errorsText = Object.values(result.errors).flat().join("\n");
          Swal.fire("Errores de validación", errorsText, "error");
        } else {
          throw new Error(result.message || "Error al guardar usuario");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", error.message, "error");
    } finally {
      setSaving(false);
    }
  };

  const handleInvite = async (e) => {
    e.preventDefault();

    // ✅ VALIDAR que si tiene rol conductor, haya seleccionado uno
    if (tieneRolConductor() && !conductorSeleccionado) {
      Swal.fire("Error", "Debes seleccionar un conductor", "error");
      return;
    }

    setSaving(true);

    try {
      // ✅ CONSTRUIR EL PAYLOAD CON conductor_id
      const payload = {
        name: formInvite.name,
        email: formInvite.email,
        roles: formInvite.roles,
        conductor_id: conductorSeleccionado?.id || null, // ← AGREGAR ESTO
      };

      const response = await fetch(`${getApiUrl()}/users/invite`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload), // ← Usar payload en lugar de formInvite
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Invitación enviada",
          text: `Se envió una invitación a ${formInvite.email}`,
          timer: 3000,
        });

        // ✅ RESETEAR TODO incluyendo el conductor seleccionado
        setFormInvite({ name: "", email: "", roles: [] });
        setConductorSeleccionado(null); // ← AGREGAR ESTO
        loadInvitaciones();
      } else {
        if (result.errors) {
          const errorsText = Object.values(result.errors).flat().join("\n");
          Swal.fire("Errores de validación", errorsText, "error");
        } else {
          throw new Error(result.message || "Error al enviar invitación");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", error.message, "error");
    } finally {
      setSaving(false);
    }
  };
  const handleToggleActive = async (usuario) => {
    try {
      const response = await fetch(
        `${getApiUrl()}/users/${usuario.id}/toggle-active`,
        {
          method: "PATCH",
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Estado actualizado",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
        });
        loadUsuarios();
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "No se pudo cambiar el estado", "error");
    }
  };

  const handleResendInvitation = async (invitationId) => {
    try {
      const response = await fetch(
        `${getApiUrl()}/users/invitations/${invitationId}/resend`,
        {
          method: "POST",
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Invitación reenviada",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
        });
        loadInvitaciones();
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "No se pudo reenviar la invitación", "error");
    }
  };

  // const getRolesDisponibles = () => {
  //   if (formConfig.can_create_direct && formData.empresa_id) {
  //     // Super Admin: roles de la empresa seleccionada
  //     return formConfig.all_roles[formData.empresa_id] || [];
  //   } else {
  //     // Admin Local: roles de su empresa
  //     return formConfig.roles || [];
  //   }
  // };
  const getRolesDisponibles = () => {
    // Si es Super Admin y hay una empresa seleccionada
    if (formConfig.can_create_direct && formData.empresa_id) {
      // Buscamos los roles específicos de esa empresa en el diccionario 'all_roles'
      // y también incluimos los globales si existen
      const rolesEmpresa = formConfig.all_roles?.[formData.empresa_id] || [];
      const rolesGlobales = formConfig.all_roles?.global || [];

      return [...rolesEmpresa, ...rolesGlobales];
    }

    // Si es Admin Local, usa los roles que ya vienen filtrados para su empresa
    return formConfig.roles || [];
  };

  const getInvitationStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return (
          <Badge className="bg-yellow-100 text-yellow-700 text-xs">
            <Clock className="h-3 w-3 mr-1" /> Pendiente
          </Badge>
        );
      case "accepted":
        return (
          <Badge className="bg-green-100 text-green-700 text-xs">
            <CheckCircle className="h-3 w-3 mr-1" /> Aceptada
          </Badge>
        );
      case "expired":
        return (
          <Badge className="bg-red-100 text-red-700 text-xs">
            <XCircle className="h-3 w-3 mr-1" /> Expirada
          </Badge>
        );
      default:
        return <Badge variant="outline">{status}</Badge>;
    }
  };

  const toggleRoleSelection = (roleId) => {
    if (formInvite.roles.includes(roleId)) {
      setFormInvite({
        ...formInvite,
        roles: formInvite.roles.filter((id) => id !== roleId),
      });
    } else {
      setFormInvite({
        ...formInvite,
        roles: [...formInvite.roles, roleId],
      });
    }
  };

  const toggleRoleSelectionUser = (roleId) => {
    if (formData.roles.includes(roleId)) {
      setFormData({
        ...formData,
        roles: formData.roles.filter((id) => id !== roleId),
      });
    } else {
      setFormData({
        ...formData,
        roles: [...formData.roles, roleId],
      });
    }
  };

  return (
    <div className="space-y-3">
      {/* Header */}
      <Card>
        <CardHeader className="pb-2 pt-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-blue-600" />
              <CardTitle className="text-sm">
                {formConfig.can_create_direct
                  ? "Usuarios del Sistema"
                  : `Usuarios - ${formConfig.admin_empresa?.nombre || "Mi Empresa"
                  }`}
              </CardTitle>
              <Badge variant="outline" className="text-xs">
                {pagination.total} usuarios
              </Badge>
            </div>
            <div className="flex gap-1.5">
              <Button
                variant="outline"
                size="sm"
                onClick={loadUsuarios}
                disabled={loading}
                className="h-7 text-xs"
              >
                <RefreshCw
                  className={`h-3 w-3 ${loading ? "animate-spin" : ""}`}
                />
              </Button>

              {/* Botón Crear (Solo Super Admin) */}
              {formConfig.can_create_direct && (
                <Button
                  size="sm"
                  onClick={handleOpenCreateModal}
                  className="bg-blue-600 hover:bg-blue-700 h-7 text-xs"
                >
                  <Plus className="h-3 w-3 mr-1" />
                  Crear Usuario
                </Button>
              )}

              {/* Botón Invitar (Solo Admin Local) */}
              {formConfig.can_invite && (
                <Button
                  size="sm"
                  onClick={handleOpenInviteModal}
                  className="bg-green-600 hover:bg-green-700 h-7 text-xs"
                >
                  <UserPlus className="h-3 w-3 mr-1" />
                  Invitar Usuario
                </Button>
              )}
            </div>
          </div>
        </CardHeader>
      </Card>

      {/* Filtros */}
      <Card>
        <CardContent className="pt-2 pb-2">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-1.5">
            <div className="relative">
              <Search className="absolute left-2 top-2 h-3.5 w-3.5 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar por nombre, email..."
                className="w-full pl-7 pr-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                value={filters.buscar}
                onChange={(e) =>
                  setFilters({ ...filters, buscar: e.target.value })
                }
              />
            </div>

            {formConfig.can_create_direct && (
              <select
                className="px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                value={filters.empresa_id}
                onChange={(e) =>
                  setFilters({ ...filters, empresa_id: e.target.value })
                }
              >
                <option value="">Todas las empresas</option>
                {formConfig.empresas?.map((empresa) => (
                  <option key={empresa.id} value={empresa.id}>
                    {empresa.nombre}
                  </option>
                ))}
              </select>
            )}

            <select
              className="px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={filters.active}
              onChange={(e) =>
                setFilters({ ...filters, active: e.target.value })
              }
            >
              <option value="">Todos los estados</option>
              <option value="true">Activos</option>
              <option value="false">Inactivos</option>
            </select>

            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                setFilters({
                  buscar: "",
                  active: "",
                  tipo: "",
                  empresa_id: "",
                })
              }
              className="text-xs h-7"
            >
              Limpiar filtros
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Tabla */}
      <Card>
        <CardContent className="p-0">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="h-5 w-5 animate-spin text-blue-600" />
              <span className="ml-2 text-xs text-gray-600">Cargando...</span>
            </div>
          ) : usuarios.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              <Users className="h-12 w-12 mx-auto mb-3 text-gray-300" />
              <p className="text-sm mb-2">No hay usuarios</p>
              {formConfig.can_invite && (
                <Button
                  size="sm"
                  onClick={handleOpenInviteModal}
                  className="bg-green-600 hover:bg-green-700"
                >
                  <UserPlus className="h-4 w-4 mr-1" />
                  Invitar primer usuario
                </Button>
              )}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-xs">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                      Usuario
                    </th>
                    {formConfig.can_create_direct && (
                      <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                        Empresa
                      </th>
                    )}
                    <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                      Roles
                    </th>
                    <th className="px-2 py-1.5 text-center font-medium text-gray-700">
                      Estado
                    </th>
                    <th className="px-2 py-1.5 text-center font-medium text-gray-700">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {usuarios.map((usuario) => (
                    <tr key={usuario.id} className="hover:bg-gray-50">
                      <td className="px-2 py-1.5">
                        <div className="font-medium text-gray-900">
                          {usuario.name}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-gray-500">
                          <Mail className="h-3 w-3" />
                          {usuario.email}
                        </div>
                        <Badge className="text-xs mt-1">
                          {formConfig.tipos?.[usuario.tipo] || usuario.tipo}
                        </Badge>
                      </td>
                      {formConfig.can_create_direct && (
                        <td className="px-2 py-1.5">
                          {usuario.empresa && (
                            <div className="flex items-center gap-1">
                              <Building2 className="h-3 w-3 text-gray-400" />
                              <span className="text-xs">
                                {usuario.empresa.nombre}
                              </span>
                            </div>
                          )}
                        </td>
                      )}
                      <td className="px-2 py-1.5">
                        <div className="flex flex-wrap gap-1">
                          {usuario.roles?.map((rol) => (
                            <Badge
                              key={rol.id}
                              variant="outline"
                              className="text-xs"
                            >
                              <Shield className="h-3 w-3 mr-1" />
                              {rol.name}
                            </Badge>
                          ))}
                        </div>
                      </td>
                      <td className="px-2 py-1.5 text-center">
                        <button
                          onClick={() => handleToggleActive(usuario)}
                          className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium ${usuario.active
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                            }`}
                        >
                          <Power className="h-3 w-3" />
                          {usuario.active ? "Activo" : "Inactivo"}
                        </button>
                      </td>
                      <td className="px-2 py-1.5">
                        <div className="flex items-center justify-center gap-0.5">
                          <button
                            onClick={() => handleEdit(usuario)}
                            className="p-1 hover:bg-blue-50 rounded transition-colors"
                            title="Editar"
                          >
                            <Edit className="h-3.5 w-3.5 text-blue-600" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Paginación */}
          {pagination.total > 0 && (
            <div className="flex items-center justify-between px-2 py-1.5 border-t bg-gray-50">
              <div className="text-xs text-gray-600">
                Mostrando {pagination.from} - {pagination.to} de{" "}
                {pagination.total}
              </div>
              <div className="flex gap-1">
                <Button
                  variant="outline"
                  size="sm"
                  className="h-6 text-xs px-2"
                  disabled={pagination.current_page === 1}
                  onClick={() =>
                    setPagination({
                      ...pagination,
                      current_page: pagination.current_page - 1,
                    })
                  }
                >
                  Anterior
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  className="h-6 text-xs px-2"
                  disabled={pagination.current_page === pagination.last_page}
                  onClick={() =>
                    setPagination({
                      ...pagination,
                      current_page: pagination.current_page + 1,
                    })
                  }
                >
                  Siguiente
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      {/* MODAL CREAR/EDITAR USUARIO */}
      {showModal && (formConfig.can_create_direct || editingUsuario) && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
          <Card className="w-full max-w-2xl max-h-[95vh] overflow-y-auto">
            <CardHeader className="pb-2 pt-3 border-b">
              <div className="flex items-center justify-between">
                <CardTitle className="text-sm">
                  {editingUsuario ? "Editar Usuario" : "Crear Usuario"}
                </CardTitle>
                <button
                  onClick={() => setShowModal(false)}
                  className="p-1 hover:bg-gray-200 rounded"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>
            <CardContent className="pt-3">
              <form onSubmit={handleSubmit} className="space-y-3">
                <div className="grid grid-cols-2 gap-2">
                  <div className="col-span-2">
                    <label className="block text-xs font-medium mb-1">
                      Nombre Completo <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-2 py-1.5 text-xs border rounded-md"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      required
                      className="w-full px-2 py-1.5 text-xs border rounded-md"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Contraseña{" "}
                      {!editingUsuario && (
                        <span className="text-red-500">*</span>
                      )}
                    </label>
                    <input
                      type="password"
                      required={!editingUsuario}
                      minLength={8}
                      className="w-full px-2 py-1.5 text-xs border rounded-md"
                      value={formData.password}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                      placeholder={
                        editingUsuario ? "Dejar vacío para mantener" : ""
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Empresa <span className="text-red-500">*</span>
                    </label>
                    <select
                      required
                      disabled={!formConfig.can_create_direct}
                      className="w-full px-2 py-1.5 text-xs border rounded-md disabled:bg-gray-100 disabled:text-gray-500"
                      value={formData.empresa_id}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          empresa_id: e.target.value,
                          roles: [], // Reset roles al cambiar empresa
                        })
                      }
                    >
                      <option value="">Seleccionar empresa...</option>
                      {formConfig.empresas?.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.nombre}
                        </option>
                      ))}
                      {!formConfig.can_create_direct && formConfig.admin_empresa && (
                        <option value={formConfig.admin_empresa.id}>
                          {formConfig.admin_empresa.nombre}
                        </option>
                      )}
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1">
                      Tipo <span className="text-red-500">*</span>
                    </label>
                    <select
                      required
                      disabled={!formConfig.can_create_direct}
                      className="w-full px-2 py-1.5 text-xs border rounded-md disabled:bg-gray-100 disabled:text-gray-500"
                      value={formData.tipo}
                      onChange={(e) =>
                        setFormData({ ...formData, tipo: e.target.value })
                      }
                    >
                      {Object.entries(formConfig.tipos || {}).map(
                        ([key, label]) => (
                          <option key={key} value={key}>
                            {label}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                </div>

                {/* Roles */}
                {(formData.empresa_id || !formConfig.can_create_direct) && getRolesDisponibles().length > 0 && (
                  <div className="border rounded-lg p-3">
                    <label className="block text-xs font-medium mb-2">
                      Roles <span className="text-red-500">*</span>
                    </label>
                    <div className="space-y-1 max-h-32 overflow-y-auto">
                      {getRolesDisponibles().map((rol) => (
                        <div key={rol.id} className="flex items-center gap-2">
                          <Checkbox
                            checked={formData.roles.includes(rol.id)}
                            onCheckedChange={() =>
                              toggleRoleSelectionUser(rol.id)
                            }
                          />
                          <label className="text-xs">
                            <span className="font-medium">{rol.name}</span>
                            {rol.is_system_role && (
                              <Badge
                                variant="secondary"
                                className="ml-2 text-xs"
                              >
                                Global
                              </Badge>
                            )}
                            {rol.description && (
                              <span className="text-gray-500 ml-1">
                                - {rol.description}
                              </span>
                            )}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={formData.active}
                    onCheckedChange={(checked) =>
                      setFormData({ ...formData, active: checked })
                    }
                  />
                  <label className="text-xs">Usuario activo</label>
                </div>

                <div className="flex justify-end gap-2 pt-2 border-t">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </Button>
                  <Button type="submit" size="sm" disabled={saving}>
                    {saving ? (
                      <>
                        <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                        Guardando...
                      </>
                    ) : (
                      <>
                        <Save className="h-3 w-3 mr-1" />
                        {editingUsuario ? "Actualizar" : "Crear"}
                      </>
                    )}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      )}

      {/* MODAL INVITAR USUARIO (Admin Local) */}
      {showInviteModal && formConfig.can_invite && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
          <Card className="w-full max-w-3xl max-h-[95vh] overflow-hidden">
            <CardHeader className="pb-2 pt-3 border-b">
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="text-sm">Invitar Usuario</CardTitle>
                  <p className="text-xs text-gray-600 mt-1">
                    {formConfig.admin_empresa?.nombre}
                  </p>
                </div>
                <button
                  onClick={() => setShowInviteModal(false)}
                  className="p-1 hover:bg-gray-200 rounded"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>
            <CardContent className="pt-3 max-h-[calc(95vh-100px)] overflow-y-auto">
              <div className="grid grid-cols-2 gap-4">
                {/* Formulario de invitación */}
                <div className="space-y-3">
                  <h3 className="text-sm font-semibold border-b pb-2">
                    Nueva Invitación
                  </h3>
                  <form onSubmit={handleInvite} className="space-y-3">
                    <div>
                      <label className="block text-xs font-medium mb-1">
                        Nombre Completo <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        className="w-full px-2 py-1.5 text-xs border rounded-md"
                        value={formInvite.name}
                        onChange={(e) =>
                          setFormInvite({ ...formInvite, name: e.target.value })
                        }
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium mb-1">
                        Email <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        required
                        className="w-full px-2 py-1.5 text-xs border rounded-md"
                        value={formInvite.email}
                        onChange={(e) =>
                          setFormInvite({
                            ...formInvite,
                            email: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="border rounded-lg p-3">
                      <label className="block text-xs font-medium mb-2">
                        Roles <span className="text-red-500">*</span>
                      </label>
                      <div className="space-y-1 max-h-40 overflow-y-auto">
                        {formConfig.roles?.map((rol) => (
                          <div
                            key={rol.id}
                            className="flex items-center gap-2 p-1.5 hover:bg-gray-50 rounded"
                          >
                            <Checkbox
                              checked={formInvite.roles.includes(rol.id)}
                              onCheckedChange={() =>
                                toggleRoleSelection(rol.id)
                              }
                            />
                            <label className="text-xs flex-1 cursor-pointer">
                              <span className="font-medium">{rol.name}</span>
                              {rol.description && (
                                <span className="text-gray-500 ml-1">
                                  - {rol.description}
                                </span>
                              )}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Dentro del formulario de invitación, después de los roles */}
                    {tieneRolConductor() && (
                      <div className="border rounded-lg p-3 bg-blue-50">
                        <label className="block text-xs font-medium mb-2 text-blue-900">
                          Seleccionar Conductor{" "}
                          <span className="text-red-500">*</span>
                        </label>

                        {conductorSeleccionado ? (
                          <div className="flex items-center justify-between bg-white p-2 rounded border border-blue-200">
                            <div className="flex items-center gap-2">
                              <CreditCard className="h-4 w-4 text-blue-600" />
                              <div>
                                <p className="text-xs font-medium">
                                  {conductorSeleccionado.nombre}{" "}
                                  {conductorSeleccionado.apellidos}
                                </p>
                                <p className="text-xs text-gray-500">
                                  DNI: {conductorSeleccionado.dni}
                                </p>
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={() => setConductorSeleccionado(null)}
                              className="text-red-600 hover:bg-red-100 p-1 rounded"
                            >
                              <X className="h-4 w-4" />
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              loadConductoresDisponibles();
                              setShowConductorModal(true);
                            }}
                            className="w-full px-3 py-2 text-sm bg-white border border-blue-300 hover:bg-blue-50 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
                          >
                            <Search className="h-4 w-4" />
                            Buscar Conductor
                          </button>
                        )}

                        <p className="text-xs text-blue-700 mt-2">
                          💡 Selecciona el conductor que recibirá esta
                          invitación
                        </p>
                      </div>
                    )}
                    <div className="bg-blue-50 border border-blue-200 rounded p-2">
                      <p className="text-xs text-blue-800">
                        💡 Se enviará un email con un enlace para que el usuario
                        configure su contraseña
                      </p>
                    </div>

                    <Button
                      type="submit"
                      className="w-full bg-green-600 hover:bg-green-700"
                      disabled={saving || formInvite.roles.length === 0}
                    >
                      {saving ? (
                        <>
                          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                          Enviando...
                        </>
                      ) : (
                        <>
                          <Send className="h-4 w-4 mr-2" />
                          Enviar Invitación
                        </>
                      )}
                    </Button>
                  </form>
                </div>

                {/* Lista de invitaciones pendientes */}
                <div className="space-y-3">
                  <h3 className="text-sm font-semibold border-b pb-2">
                    Invitaciones Pendientes
                  </h3>
                  {invitaciones.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                      <Mail className="h-8 w-8 mx-auto mb-2 text-gray-300" />
                      <p className="text-xs">No hay invitaciones pendientes</p>
                    </div>
                  ) : (
                    <div className="space-y-2 max-h-96 overflow-y-auto">
                      {invitaciones.map((inv) => (
                        <div
                          key={inv.id}
                          className="border rounded-lg p-2 hover:bg-gray-50"
                        >
                          <div className="flex items-start justify-between mb-1">
                            <div className="flex-1">
                              <div className="font-medium text-xs">
                                {inv.name}
                              </div>
                              <div className="text-xs text-gray-500">
                                {inv.email}
                              </div>
                            </div>
                            {getInvitationStatusBadge(inv.status)}
                          </div>
                          <div className="flex items-center justify-between text-xs text-gray-500">
                            <span>
                              Expira:{" "}
                              {new Date(inv.expires_at).toLocaleDateString()}
                            </span>
                            {inv.status === "pending" && (
                              <button
                                onClick={() => handleResendInvitation(inv.id)}
                                className="text-blue-600 hover:underline"
                              >
                                Reenviar
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {/* Modal de Selección de Conductores */}
      {showConductorModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-3">
          <Card className="w-full max-w-2xl max-h-[80vh] overflow-hidden">
            <CardHeader className="pb-2 pt-3 border-b">
              <div className="flex items-center justify-between">
                <CardTitle className="text-sm">Seleccionar Conductor</CardTitle>
                <button
                  onClick={() => setShowConductorModal(false)}
                  className="p-1 hover:bg-gray-200 rounded"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>
            <CardContent className="pt-3 max-h-[calc(80vh-100px)] overflow-y-auto">
              <div className="space-y-2">
                {conductoresDisponibles.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <Users className="h-12 w-12 mx-auto mb-3 text-gray-300" />
                    <p className="text-sm">No hay conductores registrados</p>
                  </div>
                ) : (
                  conductoresDisponibles.map((conductor) => (
                    <div
                      key={conductor.id}
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        setConductorSeleccionado(conductor);
                        setShowConductorModal(false);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          setConductorSeleccionado(conductor);
                          setShowConductorModal(false);
                        }
                      }}
                      className="border rounded-lg p-3 hover:bg-blue-50 hover:border-blue-300 cursor-pointer transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="bg-blue-100 p-2 rounded-lg">
                            <Users className="h-5 w-5 text-blue-600" />
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-900">
                              {conductor.nombre} {conductor.apellidos}
                            </p>
                            <div className="flex items-center gap-3 mt-1">
                              <span className="text-xs text-gray-600 flex items-center gap-1">
                                <CreditCard className="h-3 w-3" />
                                {conductor.dni}
                              </span>
                              <span className="text-xs text-gray-600 flex items-center gap-1">
                                <Phone className="h-3 w-3" />
                                {conductor.telefono || "Sin teléfono"}
                              </span>
                            </div>
                          </div>
                        </div>
                        <Badge className="text-xs bg-green-100 text-green-700">
                          {conductor.licencia_categoria}
                        </Badge>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};

export default GestionUsuarios;
